import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-2 grid-rows-2 gap-3 w-1/2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", null, "Use new site design", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("label", null, "Hover to open sidebar", -1);
import { ref, onMounted } from 'vue';
import { useUserPreferences, useHandleError, useToastNotifications } from '@apparatix/composables';
import InputSwitch from 'primevue/inputswitch';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DesignSettings',
    props: {
        newNavEnabledGlobally: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { getPreferences, updateCollapsePreference, updateDesignPreference } = useUserPreferences();
        const { showSuccess } = useToastNotifications();
        const errorHandler = useHandleError();
        const useNewDesign = ref(false);
        const hoverToOpen = ref(false);
        onMounted(async () => {
            const prefs = await getPreferences();
            if (!prefs.useNewDesign && props.newNavEnabledGlobally) {
                useNewDesign.value = true;
            }
            else if (prefs.useNewDesign) {
                useNewDesign.value = true;
            }
            else {
                useNewDesign.value = false;
            }
            hoverToOpen.value = prefs.collapseSidebar;
        });
        const updateSidebarPreference = async () => {
            const result = await updateCollapsePreference(hoverToOpen.value ? 'hto' : 'so');
            if (!result) {
                errorHandler.handleError({ message: 'Error', toastDetail: 'Error saving sidebar preference', logToSentry: true });
            }
            else {
                showSuccess('Your preference was saved successfully');
            }
        };
        const saveDesignPreference = async () => {
            const result = await updateDesignPreference(useNewDesign.value);
            if (!result) {
                errorHandler.handleError({ message: 'Error', toastDetail: 'Error saving sidebar preference', logToSentry: true });
            }
            else {
                window.location.reload();
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_unref(InputSwitch), {
                    modelValue: useNewDesign.value,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((useNewDesign).value = $event)),
                        saveDesignPreference
                    ],
                    "aria-label": "Use new site design"
                }, null, 8, ["modelValue"]),
                _hoisted_3,
                _createVNode(_unref(InputSwitch), {
                    modelValue: hoverToOpen.value,
                    "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event) => ((hoverToOpen).value = $event)),
                        updateSidebarPreference
                    ],
                    "aria-label": "Hover to open sidebar"
                }, null, 8, ["modelValue"])
            ]));
        };
    }
});
